import { render, staticRenderFns } from "./AgentTaskDetailPanel.vue?vue&type=template&id=05891894&scoped=true"
import script from "./AgentTaskDetailPanel.vue?vue&type=script&lang=js"
export * from "./AgentTaskDetailPanel.vue?vue&type=script&lang=js"
import style0 from "./AgentTaskDetailPanel.vue?vue&type=style&index=0&id=05891894&prod&lang=scss&scoped=true"
import style1 from "./AgentTaskDetailPanel.vue?vue&type=style&index=1&id=05891894&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05891894",
  null
  
)

export default component.exports